import { render } from "./About1.vue?vue&type=template&id=0aa1bc06"
import script from "./About1.vue?vue&type=script&lang=js"
export * from "./About1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__